import * as actionTypes from '../actions/types';

const savedUser = localStorage.getItem('user');

const initialState = {
    user: savedUser !== undefined ? savedUser : null,
    error: null,
    isVerifying: false
}

const authReducer = (state=initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_SUCCESS:
            return {...state, user: action.user, isVerifying: action.isVerifying};

        case actionTypes.AUTH_FAIL:
            return {...state, error: action.error};

        case actionTypes.AUTH_LOGOUT:
            return {...state, user: null};

        case actionTypes.AUTH_CHANGE_PASSWORD:
            return {...state, error: action.error};

        case actionTypes.AUTH_FORGOT_PASSWORD:
            return {...state, error: action.error};
    
        default:
            return state;
    }
}

export default authReducer;